<template>
  <div class="WuJieTemp">
    <WujieVue width="100%" height="100%" name="WuJieTemp" :url="url"></WujieVue>
  </div>
</template>

<script>
import hostMap from '../../../wujie-config/hostMap'
import wujieVue from 'wujie-vue2'

export default {
  computed: {
    url() {
      return hostMap('wuJieTempUrl') + this.$route.path
    }
  },
  watch: {
    '$route.params': {
      handler: function () {
        wujieVue.bus.$emit('WuJieTemp-router-change', this.$route.path.replace('/wuJieTemp', ''))
      },
      immediate: true
    }
  },
  methods: {
    jump(name) {
      this.$router.push({ name })
    }
  }
}
</script>

<style scoped>
.WuJieTemp {
  padding: 20px;
  background-color: #fff;
  height: 100%;
}
.url {
  color: var(--test);
}
</style>
